import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';
import type { TypeBlogPostSkeleton } from './TypeBlogPost';
import type { TypeBudget_itemSkeleton } from './TypeBudget_item';
import type { TypeImageLinkSkeleton } from './TypeImageLink';
import type { TypeImpacterSkeleton } from './TypeImpacter';
import type { TypeLinkSkeleton } from './TypeLink';
import type { TypeOrientedMediaSkeleton } from './TypeOrientedMedia';
import type { TypeProfileSkeleton } from './TypeProfile';

export interface TypeCategoryPageFields {
  name: EntryFieldTypes.Symbol;
  title: EntryFieldTypes.Symbol;
  slug?: EntryFieldTypes.Symbol;
  topVideo?: EntryFieldTypes.Symbol;
  topMedia?: EntryFieldTypes.EntryLink<TypeOrientedMediaSkeleton>;
  introHeadline?: EntryFieldTypes.Symbol;
  description?: EntryFieldTypes.Text;
  aboutTheFund?: EntryFieldTypes.RichText;
  featuredArticles?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeBlogPostSkeleton>>;
  advisoryGroupProfiles?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeProfileSkeleton>>;
  fundManagerProfiles?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeProfileSkeleton>>;
  budget_items?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeBudget_itemSkeleton>>;
  awardsAndStandards?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeImageLinkSkeleton>>;
  links?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeLinkSkeleton>>;
  thankYouMedia?: EntryFieldTypes.EntryLink<TypeOrientedMediaSkeleton>;
  thankYouMediaImpacter?: EntryFieldTypes.EntryLink<TypeImpacterSkeleton>;
  devEnvironment?: EntryFieldTypes.Symbol;
}

export type TypeCategoryPageSkeleton = EntrySkeletonType<TypeCategoryPageFields, 'categoryPage'>;
export type TypeCategoryPage<
  Modifiers extends ChainModifiers = 'WITHOUT_UNRESOLVABLE_LINKS',
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeCategoryPageSkeleton, Modifiers, Locales>;

export function isTypeCategoryPage<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeCategoryPage<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'categoryPage';
}
